import { useFormContext, Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import useFormPersist from "react-hook-form-persist";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import styles from "../../styles/PhoneNumberInput.scss";
import { useStorage } from "hooks/useStorage";
import { useState } from "react";

interface Props {
  id: string;
  required: boolean;
  name: string;
  type?: string;
}

export const PhoneNumberInput = ({ name, required, id }: Props) => {
  const { hasValue, storageValue } = useStorage(id);
  const [phone] = useState<string>(storageValue);
  const {
    control,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();
  useFormPersist("onboarding", {
    watch,
    setValue,
    storage: window.localStorage,
  });

  const errorMessage = required && "Este campo debe ser completado";

  return (
    <div className={styles.formItem}>
      <div className={styles.form}>
        <Controller
          control={control}
          name={name}
          rules={{ required: errorMessage }}
          render={({ field: { ref, value, name, ...field } }) => (
            <>
              <PhoneInput
                {...field}
                value={hasValue ? phone : value}
                country={"co"}
              />
              <ErrorMessage
                errors={errors}
                name={name}
                render={({ message }) => (
                  <span className="form__error">{message}</span>
                )}
              />
            </>
          )}
        />
      </div>
    </div>
  );
};
